import Vue from 'vue'; 

// Create a new Vue instance and export it 
const EventBus = new Vue(); 

export default EventBus;
